import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import * as basketActions from 'actions/basketActions';
import * as pageActionsV4 from 'actions/pageActionsV4';
const { basketActionsEnum } = basketActions;
const { PAGE_DATA_ACTIONS } = pageActionsV4;
const defaultState = {
    listingIds: [],
    offerData: {}
};
function getOfferDataFromProductSwatch(products, parentListingId) {
    const offerData = {};
    for (const listingId in products) {
        if (products.hasOwnProperty(listingId)) {
            const product = products[listingId];
            if (listingId === parentListingId) {
                continue;
            }
            offerData[listingId] = product.offers;
        }
    }
    return offerData;
}
export default function offersReducer(state = defaultState, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            const filteredSlotData = (get(action.data, ['slots']) || []).filter(slot => {
                return Boolean(slot.widget && slot.widget.type === WidgetTypeV4.PRODUCT_SUMMARY_EXTENDED);
            });
            const allProducts = filteredSlotData.reduce((acc, cur) => {
                return acc.concat(get(cur, ['widget', 'data', 'products']) ||
                    []);
            }, []);
            if (isEmpty(allProducts)) {
                return state;
            }
            return allProducts.reduce((acc, cur) => {
                const listingId = get(cur, [
                    'productInfo',
                    'value',
                    'listingId'
                ]);
                const offers = get(cur, ['productInfo', 'value', 'offers']);
                if (!listingId) {
                    return acc;
                }
                const productSwatchOfferData = {} ||
                    getOfferDataFromProductSwatch(get(cur, [
                        'productInfo',
                        'value',
                        'productSwatch',
                        'products'
                    ]), listingId);
                return {
                    listingIds: [...acc.listingIds, ...Object.keys(productSwatchOfferData), listingId],
                    offerData: Object.assign(Object.assign(Object.assign({}, acc.offerData), productSwatchOfferData), { [listingId]: offers })
                };
            }, {
                listingIds: [],
                offerData: {}
            });
        case basketActionsEnum.ADD_TO_BASKET_SUCCESS:
        case basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS:
            const offerData = get(action.data, [
                'offerData'
            ]) || {};
            return {
                listingIds: state.listingIds,
                offerData: Object.assign(Object.assign({}, state.offerData), offerData)
            };
        default:
            return state;
    }
}
